module.exports = __webpack_public_path__ + "img/horizontal_4_4_9016.663dfd1e.png";